/* (ignored) */


//////////////////
// WEBPACK FOOTER
// min-document (ignored)
// module id = 1185
// module chunks = 0